import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { CommonService } from './common.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MyBookingGuard implements CanActivate {

  private pagePermissions = {
    '/bookings': {name: 'My Bookings'},
  };
  private isPermissionsSet: boolean;

  constructor(
    private authService: AuthService,
    private router: Router,
    private commonService: CommonService
  ) { }

  public setPagePermissions(config) {
    const myBookingConfig = this.commonService.getConfigForElementKey(config, 'My Bookings');
    if (myBookingConfig.config.visibility.visible) {
      this.isPermissionsSet = true;
    }
  }

  canActivate(activatedRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (this.checkRiderApprovalFlow(activatedRoute)) {
    if (this.isPermissionsSet) {
      return true;
    } else {
      if (this.checkRiderApprovalFlow) {
        return new Observable(observer => {
          this.commonService.fetchConfig().subscribe((config) => {
            this.setPagePermissions(config);
            if (this.isPermissionsSet) {
              observer.next(true);
            } else {
              this.router.navigate(['404']);
            }
          });
        });
      }
    }
  }
}

  checkRiderApprovalFlow(activatedRoute: ActivatedRouteSnapshot)  {
    if (activatedRoute.queryParams &&
      activatedRoute.queryParams['bookingId'] &&
      activatedRoute.queryParams['startDate'] &&
      activatedRoute.queryParams['client']
    ) {
      localStorage.setItem('bookingId', activatedRoute.queryParams['bookingId']);
      localStorage.setItem('startDate', activatedRoute.queryParams['startDate']);
      localStorage.setItem('client', activatedRoute.queryParams['client']);
    }
    return this.checkAuthentication();
  }

  checkAuthentication() {
    if (this.authService.isAuthenticated()) {
      return true;
    }
    const client = localStorage.getItem('client');
    this.router.navigate([`${client}/login`]);
    return false;
  }
}
